<template>
  <div class="container page service-page">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar service-nav">
        <template #left>
          <van-icon name="arrow-left" class="nav-back" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="page-body">
      <div class="service-card">
        <div class="service-top">
          <img class="service-image" src="img/mine/kefu.png">
          <div class="service-main">
            <div class="service-title">{{this.$store.getters.getBaseInfo.name !== undefined ? this.$store.getters.getBaseInfo.name : this.$t("my.title")}}</div>
            <div class="service-subtitle">{{$t("my.online_service")}}</div>
          </div>
          <div class="service-btn" @click="toServicePage()">
            <div class="service-btn-text">{{$t("my.contact")}}</div>
          </div>
        </div>
        <div class="service-bottom">
          <div class="service-info-text">{{$t("my.service_time")}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toServicePage(){
      const service = this.$store.getters.getBaseInfo;
      if (service.iskefu == 1){
        window.location.href = service.kefu
      }
      // this.$router.push("ServicePage");
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.service-page {
  min-height: 100%;
  background: #f5f5f5;
}

.page-body {
  padding: 16px;
}

.service-card{
  display: flex;
  flex-direction: column;
  padding: 32px 30px;
  border-radius: 20px;
  justify-content: space-between;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
}
.service-top{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 112px;
}
.service-image{
  width: 88px;
  height: 88px;
  border-radius: 50%;
}

.service-main {
  flex: 1;
  min-width: 0;
  margin-left: 28px;
}

.service-title{
  font-size: 38px;
  font-weight: 700;
  color: #000;
  line-height: 52px;
}

.service-subtitle {
  margin-top: 8px;
  color: #9d9d9d;
  font-size: 24px;
  line-height: 34px;
}

.service-btn{
  display: flex;
  width: 176px;
  height: 64px;
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #6667e8 0%, #5d63e1 100%);
}

.service-btn-text{
  color: #fff;
  font-size: 26px;
  font-weight: 700;
}

.service-bottom{
  margin-top: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 68px;
  background: #f5f5f5;
  border-radius: 12px;
  color: #979799;
}

.service-info-text{
  font-size: 28px;
}

::v-deep .service-nav {
  background: #fff;
}

::v-deep .service-nav .van-nav-bar__title {
  color: #000;
  font-weight: 500;
}

::v-deep .service-nav::after {
  border-bottom: 1px solid #ededed;
}

.nav-back {
  color: #8795ad;
}
</style>
